<!--*****************************************************************
  * Copyright (c) Certus Software, 2021.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<footer class="{{translate.currentLang}}">
  <section class="footer-section">
    <div class="top-border"></div>
    <div class="inner">
      <div class="inner-grid">
        <div class="logos">
          <div>
            <a [routerLink]="'/'">
              <img src="./assets/img/veglegestorles-logo.svg" alt="Véglegestörlés.hu">
            </a>
          </div>
          <div>
            <a class="certus-logo" href="https://certus.software/{{translate.currentLang}}" target="_blank">
              <img src="./assets/img/Certus-software-logo-white.svg" width="158px" alt="Certus Software">
            </a>
        </div>
        </div>
        <div></div>
        <div class="footer-nav" role="navigation">
          <p class="s-h5">{{'app.footer.navigation' | translate}}</p>
          <div>
          <p *ngIf="(isLoggedIn | async)" class="small">
            <a class="" [routerLink]="'/'">{{'app.titles.myAccount' | translate}}</a>
          </p>
          <p class="small">
            <a class="" [routerLink]="'/guide'">{{'app.titles.guide' | translate}}</a>
          </p>
          <p class="small">
            <a class="" [routerLink]="'/devices/supported'">{{'app.titles.supportedDevices' | translate}}</a>
          </p>
          <p class="small">
            <a class="" [routerLink]="'/devices/unsupported'">{{'app.titles.unsupportedDevices' | translate}}</a>
          </p>
          <p *ngIf="!(isLoggedIn | async)" class="small">
            <a class="" [routerLink]="'/register'">{{'app.titles.licenseActivation' | translate}}</a>
          </p>
          <p *ngIf="!(isLoggedIn | async)" class="small">
            <a class="" [routerLink]="'/login'">{{'app.titles.login' | translate}}</a>
          </p>
          </div>
        </div>
        <div class="mobile-separator"></div>
        <div class="contact">
          <p class="s-h5">{{'app.footer.support.title' | translate}}</p>
          <p class="small">
            <a class="email" href="mailto:{{env.resources.websiteOrMail}}">{{env.resources.websiteOrMail}}</a>
          </p>
          <p class="small">
            <a href="tel:+3614680673">(06 1) 468-0673</a>
          </p>
          <p class="extra-small">
            {{'app.footer.support.availableHours' | translate}}
          </p>
        </div>
      </div>
    </div>
    <div class="sub-footer">
      <div class="inner">
        <div class="inner-grid">
          <p class="extra-small copyright">
            © {{currentYear}} Véglegestörlés.hu – {{'app.footer.subfooter.copyright1' | translate}} <span aria-hidden="true">|</span> {{'app.footer.subfooter.copyright2' | translate}}
          </p>
          <div class="sub-mobile-separator"></div>
          <p class="extra-small resources">
            <a class="" href="{{env.app_url + ('home.resources.privacyPolicyUrl' | translate)}}" target="_blank">{{'app.footer.subfooter.policy1' | translate}}</a>
            <span aria-hidden="true">|</span>
            <a class="" href="{{env.app_url + ('home.resources.eulaUrl' | translate)}}" target="_blank">{{'app.footer.subfooter.policy2' | translate}}</a>
          </p>
        </div>
      </div>
    </div>
  </section>
</footer>
